import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { TransferDto, UpdateTransferDto } from '../types';

export const useUpdateTransfer = (transferId: string) => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<TransferDto, Error, UpdateTransferDto>({
    mutationFn: (data) =>
      apiClient.patch(`/v1/projects/${projectId}/transfers/${transferId}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
      queryClient.invalidateQueries({ queryKey: ['transfer', transferId] });
    },
  });
};
